export enum JilabaKeyEnum {
CommonKey='Common@jil2020kY'
}
